import { prop } from "../../decorators/property";
import { AuthorizationModel } from "../../authentication/models/authorization-model";
import { AppSettings } from "../../app-settings";
import { Container } from "aurelia-dependency-injection";
import { AuthService } from "../../authentication/auth-service";
import { ContainerHelper } from "../../shared/helpers/container-helper";

export class AlertsReportModel extends Backbone.AssociatedModel {

    @prop() public Enabled: boolean;
    @prop() public ReportName: string;
    @prop() public ReportCode: string[];
    @prop() public Hidden: boolean;

    constructor(options?) {
        super(options);
    }

    public saveAlert() {
        const user = ContainerHelper.AuthService.AppUser;
        return new Promise<any>((resolve, reject) => {
            $.ajax({
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                type: "POST",
                url: `${AppSettings.ApiUrlPrefix}alerts/savereportalert`,
                data: {
                    Enabled: this.Enabled,
                    Recipient: user.FriendlyName + "<" + user.Email + ">",
                    ReportName: this.ReportName,
                    ReportCode: this.ReportCode
                }
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/models/alerts-report.ts